import * as Yup from "yup";

export const TransportCompanyFormSchema = Yup.object().shape({
  name: Yup.string().required("Company name is required"),
});
